module.exports = __webpack_public_path__ + "static/media/right-carousel-fadein.26ac6cc7.webp";